import { createStore } from 'vuex';
import axios from 'axios';
import { Token } from '@/api/model/token.model';

let url,
    apiPort,
    apiSubdomain,
    apiProtocol,
    ctsProtocol,
    clereTileserverSubdomain,
    clereTileserverDomain,
    clereTileserverPort,
    tileFileServerApiUrl;

url = '__CG_API_DOMAIN__';
apiPort = '__CG_API_PORT__';
apiSubdomain = '__CG_API_SUBDOMAIN__';
apiProtocol = '__CG_API_PROTOCOL__';
ctsProtocol = '__CG_CTS_PROTOCOL__';
clereTileserverSubdomain = '__CG_CTS_SUBDOMAIN__';
clereTileserverDomain = '__CG_CTS_DOMAIN__';
clereTileserverPort = '__CG_CTS_PORT__';
tileFileServerApiUrl = '__CG_TILE_FTP_URL__';

const replacePlaceholder = (varname: any, envvalue: string) => {
    if (varname === undefined) {
        varname = envvalue;
    } else if (varname.slice(0, 2) === '__' && varname.slice(-2) === '__') {
        varname = envvalue;
    }
    return varname;
};

const replaceEnvironmentVariables = () => {
    url = replacePlaceholder(url, process.env.VUE_APP_CG_API_DOMAIN);
    apiPort = replacePlaceholder(apiPort, process.env.VUE_APP_CG_API_PORT);
    apiSubdomain = replacePlaceholder(
        apiSubdomain,
        process.env.VUE_APP_CG_API_SUBDOMAIN,
    );
    apiProtocol = replacePlaceholder(
        apiProtocol,
        process.env.VUE_APP_CG_API_PROTOCOL,
    );
    ctsProtocol = replacePlaceholder(
        ctsProtocol,
        process.env.VUE_APP_CG_CTS_PROTOCOL,
    );
    clereTileserverSubdomain = replacePlaceholder(
        clereTileserverSubdomain,
        process.env.VUE_APP_CG_CTS_SUBDOMAIN,
    );

    clereTileserverDomain = replacePlaceholder(
        clereTileserverDomain,
        process.env.VUE_APP_CG_CTS_DOMAIN,
    );

    clereTileserverPort = replacePlaceholder(
        clereTileserverPort,
        process.env.VUE_APP_CG_CTS_PORT,
    );
    tileFileServerApiUrl = replacePlaceholder(
        tileFileServerApiUrl,
        process.env.VUE_APP_CG_TILE_FTP_URL,
    );
};
replaceEnvironmentVariables();

// /* local api */
// const url = 'clerenet.uk';
// const apiPort = '443';
// const apiSubdomain = 'api.';
// const apiProtocol = 'https';

// /* remote api */
// // const url = 'clerenet.uk';
// // const apiPort = '443';
// // const apiSubdomain = 'api.';
// // const apiProtocol = 'https';

// /* remote tileserver */
// // const ctsProtocol = 'https://';
// // const clereTileserverSubdomain = 'cts.dev.';
// // const clereTileserverDomain = 'cleregolfhub.com';
// // const clereTileserverPort = '';

// /* prod tileserver */
// const ctsProtocol = 'https://';
// const clereTileserverSubdomain = 'cts.';
// const clereTileserverDomain = 'cleregolfhub.com';
// const clereTileserverPort = '';

// /* local tileserver
// const ctsProtocol = 'http://';
// const clereTileserverSubdomain = '';
// const clereTileserverDomain = 'localhost';
// const clereTileserverPort = ':9000'; */

const apiUrl = apiProtocol + apiSubdomain + url + apiPort;

const ctsurl =
    ctsProtocol +
    clereTileserverSubdomain +
    clereTileserverDomain +
    clereTileserverPort;
console.log(apiUrl);
console.log(ctsurl);
console.log(tileFileServerApiUrl);
export default createStore({
    state: {
        apiUrl: apiUrl,
        tileFileServerApiUrl,
        ctsUrl: ctsurl,
        authToken: localStorage.getItem('authToken')
            ? JSON.parse(localStorage.getItem('authToken') as string)
            : null,
        accountInfo: localStorage.getItem('accountInfo')
            ? JSON.parse(localStorage.getItem('accountInfo') as string)
            : null,
        cancelToken: axios.CancelToken.source(),
        isMobile: false,
        unauthenticatedRoutes: ['/'],
        versionString: 'live-0.0.23',
    },
    mutations: {
        setAuthToken(state: any, authToken: Token) {
            localStorage.setItem('authToken', JSON.stringify(authToken));
            state.authToken = authToken;
        },
        removeAuthToken(state: any) {
            localStorage.removeItem('authToken');
            state.authToken = null;
        },
        setAccountInfo(state: any, accountInfo: any) {
            localStorage.setItem('accountInfo', JSON.stringify(accountInfo));
            state.accountInfo = accountInfo;
        },
        removeAccountInfo(state: any) {
            localStorage.removeItem('accountInfo');
            state.account = null;
        },
    },
    actions: {},
    modules: {},
    getters: {
        isLoggedIn: (state: any) => {
            return !!state.authToken;
        },
    },
});
